import { ROUTE_INFOS, RouteInfo } from '../../../../routes';

export function findItemWithParents(key: string): string[] {
  let result: string[] = [];

  function search(routes: RouteInfo[], parents: string[]): boolean {
    for (const route of routes) {
      const currentPath = [...parents, route.key];
      if (route.key === key) {
        result.push(...currentPath);
        return true;
      }
      if (route.children && search(route.children, currentPath)) {
        return true;
      }
    }
    return false;
  }

  return search(ROUTE_INFOS, []) ? result : [];
}
